/* Meno Aliv — comportamento da home (vanilla JS).
   Reproduz os hooks React do demo: autoplay do banner, carrosséis scroll-snap,
   drawers, marquee, carrinho AJAX e busca preditiva. */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var cfg = window.MNA || {};

  /* ------------------------------------------------------------------ utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  // coleta os elementos `sel` dentro de root, incluindo o próprio root se casar (Theme Editor)
  function collect(sel, root) {
    root = root || document;
    var list = $all(sel, root);
    if (root.nodeType === 1 && root.matches && root.matches(sel)) list.push(root);
    return list;
  }

  // Título de desconto vem de configuração do app e vira innerHTML.
  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || "R$ {{amount}}";
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ".";
      decimal = decimal || ",";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    var value = "";
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : "amount";
    switch (placeholder) {
      case "amount": value = withDelimiters(cents, 2, ",", "."); break;
      case "amount_no_decimals": value = withDelimiters(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = withDelimiters(cents, 2, " ", ","); break;
      case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": value = withDelimiters(cents, 0, " ", ","); break;
      default: value = withDelimiters(cents, 2, ",", ".");
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function lockScroll(lock) { document.body.style.overflow = lock ? "hidden" : ""; }

  /* ------------------------------------------------------- announcement bar */
  function initAnnouncement(root) { collect("[data-mna-announce]", root).forEach(setupAnnounce); }
  function setupAnnounce(bar) {
    if (bar.__mna) return;
    bar.__mna = true;
    var items = $all("[data-announce-item]", bar);
    var staticEl = $("[data-announce-static]", bar);
    if (items.length === 0) return;
    if (prefersReduced || items.length < 2) {
      if (staticEl && items.length >= 2) {
        staticEl.hidden = false;
        items.forEach(function (el) { el.hidden = true; });
      }
      return;
    }
    if (staticEl) staticEl.hidden = true;
    var i = 0;
    items.forEach(function (el, idx) { el.hidden = idx !== 0; });
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      var next = items[i];
      next.hidden = false;
      next.style.animation = "none";
      void next.offsetWidth;
      next.style.animation = "";
    }, 4000);
  }

  /* ------------------------------------------------------------ drawer base */
  function openDrawer(el) { if (!el) return; el.classList.add("is-open"); lockScroll(true); }
  function closeDrawer(el) { if (!el) return; el.classList.remove("is-open"); lockScroll(false); }

  function initDrawerTriggers() {
    on(document, "click", function (e) {
      var openMenu = e.target.closest("[data-menu-open]");
      if (openMenu) { openDrawer($("#mna-mobile-menu")); }
      if (e.target.closest("[data-menu-close]")) { closeDrawer($("#mna-mobile-menu")); }
      var openCart = e.target.closest("[data-cart-open]");
      if (openCart) { e.preventDefault(); openDrawer($("#mna-cart")); }
      if (e.target.closest("[data-cart-close]")) { closeDrawer($("#mna-cart")); }
    });
    on(document, "keydown", function (e) {
      if (e.key !== "Escape") return;
      $all(".drawer.is-open, .search.is-open").forEach(function (d) {
        d.classList.remove("is-open");
      });
      lockScroll(false);
    });
  }

  /* ------------------------------------------------------------- header */
  function initHeader(root) { collect("[data-mna-header]", root).forEach(setupHeader); }
  function setupHeader(header) {
    if (header.__mna) return;
    header.__mna = true;
    var onScroll = function () { header.classList.toggle("header--scrolled", window.scrollY > 8); };
    onScroll();
    on(window, "scroll", onScroll, { passive: true });
  }

  /* --------------------------------------------------------------- hero */

  // Slides 2+ do hero chegam sem src (ver mna-hero-image.liquid): estão dentro
  // da viewport com opacity:0, então loading="lazy" não os segura. Promove
  // data-src/data-srcset para os atributos reais.
  function hydrateSlide(slide) {
    if (!slide || slide.__hydrated) return;
    slide.__hydrated = true;
    $all("[data-src],[data-srcset]", slide).forEach(function (el) {
      var set = el.getAttribute("data-srcset"), src = el.getAttribute("data-src");
      if (set) { el.setAttribute("srcset", set); el.removeAttribute("data-srcset"); }
      if (src) { el.setAttribute("src", src); el.removeAttribute("data-src"); }
    });
  }

  // roda fora do caminho crítico, depois do load
  function whenIdle(fn) {
    var run = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    if (document.readyState === "complete") { run(fn); return; }
    window.addEventListener("load", function () { run(fn); });
  }

  function initHero(root) { collect("[data-mna-hero]", root).forEach(setupHero); }
  function setupHero(hero) {
    if (hero.__mna) return;
    hero.__mna = true;
    var slides = $all(".hero__slide", hero);
    var dots = $all("[data-hero-dot]", hero);
    if (slides.length < 2) return;
    var index = 0, paused = false, timer = null;
    var interval = parseInt(hero.getAttribute("data-interval"), 10) || 6000;
    var auto = hero.getAttribute("data-autorotate") === "true" && !prefersReduced;

    function go(n) {
      index = (n + slides.length) % slides.length;
      // só o alvo: prefetchar o "próximo" aqui faria o go(0) da inicialização
      // baixar o slide 2 no load, que é justamente o que o defer evita.
      hydrateSlide(slides[index]);
      slides.forEach(function (s, i) {
        var active = i === index;
        s.classList.toggle("is-active", active);
        if (active) { s.removeAttribute("inert"); } else { s.setAttribute("inert", ""); }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === index);
        d.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function tick() { if (!paused) next(); }
    function start() { if (auto) { stop(); timer = setInterval(tick, interval); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    on($("[data-hero-next]", hero), "click", function () { next(); start(); });
    on($("[data-hero-prev]", hero), "click", function () { prev(); start(); });
    dots.forEach(function (d, i) { on(d, "click", function () { go(i); start(); }); });

    on(hero, "mouseenter", function () { paused = true; });
    on(hero, "mouseleave", function () { paused = false; });
    on(hero, "focusin", function () { paused = true; });
    on(hero, "focusout", function () { paused = false; });

    var startX = null, vp = $("[data-hero-viewport]", hero);
    on(vp, "touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    on(vp, "touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); start(); }
      startX = null;
    });

    go(0);
    start();
    whenIdle(function () { slides.forEach(hydrateSlide); });
  }

  /* --------------------------------------------------- scroll-snap carousel */
  function initCarousels(root) { collect("[data-mna-carousel]", root).forEach(setupCarousel); }
  function setupCarousel(car) {
    if (car.__mna) return;
    car.__mna = true;
    var track = $("[data-carousel-track]", car);
    var prevBtn = $("[data-carousel-prev]", car);
    var nextBtn = $("[data-carousel-next]", car);
    var thumb = $("[data-carousel-thumb]", car);
    var progress = $("[data-carousel-progress]", car);
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= max - 4;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
      var frac = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      var prog = max > 0 ? track.scrollLeft / max : 0;
      if (progress) progress.style.display = frac >= 1 ? "none" : "";
      if (thumb && frac < 1) {
        var travel = ((prog * (1 - frac)) / frac) * 100;
        thumb.style.width = frac * 100 + "%";
        thumb.style.transform = "translateX(" + travel + "%)";
      }
    }
    function scroll(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: "smooth" }); }

    on(prevBtn, "click", function () { scroll(-1); });
    on(nextBtn, "click", function () { scroll(1); });
    on(track, "scroll", update, { passive: true });
    on(window, "resize", update);
    update();
  }

  /* ------------------------------------------- trust bar (autoscroll) */
  // Só na variante carrossel (setting mobile_carousel) e só quando a linha
  // transborda, ou seja, no mobile. Toque/foco/hover pausam por 6 s; no fim
  // volta ao primeiro item. Movimento reduzido desliga.
  function initTrust(root) { collect(".trust--carousel .trust__row", root).forEach(setupTrustAuto); }
  function setupTrustAuto(row) {
    if (row.__mna || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    row.__mna = true;
    var hold = 0;
    function pause() { hold = Date.now() + 6000; }
    ["touchstart", "pointerdown", "focusin", "mouseenter"].forEach(function (ev) { on(row, ev, pause, { passive: true }); });
    setInterval(function () {
      var item = $(".trust__item", row);
      if (!item || Date.now() < hold || row.scrollWidth <= row.clientWidth) return;
      var step = item.offsetWidth + (parseFloat(getComputedStyle(row).columnGap) || 0);
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      row.scrollTo({ left: atEnd ? 0 : row.scrollLeft + step, behavior: "smooth" });
    }, 1500);
  }

  /* ------------------------------------------------------------ cart (AJAX) */
  // `silent` desenha sem reanunciar: é o refresh que responde a um evento vindo
  // de fora, e quem disparou já se atualizou.
  function refreshCart(silent) {
    return fetch(cfg.routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(silent ? drawCart : renderCart);
  }

  function setCartCount(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  // A barra de metas do app (ADR 0003) só redesenha quando alguém avisa, e na
  // home v2 o mna.js é a única fonte de mudança de carrinho. Sem isso a barra
  // fica com o estado do load da página ("Faltam R$ 199,00" com carrinho cheio).
  // O `source` evita eco: o refresh que este evento provoca não pode disparar
  // outro renderCart.
  function announceCartUpdate() {
    document.dispatchEvent(
      new CustomEvent("zolve:cart:updated", { detail: { source: "mna" } })
    );
  }

  function renderCart(cart) {
    drawCart(cart);
    announceCartUpdate();
    // O comparativo chega depois e é enfeite: não pode atrasar o carrinho.
    // Repinta só quando algo novo chegou.
    loadCompareAt(cart).then(function (novo) { if (novo) drawCart(cart); });
  }

  function drawCart(cart) {
    setCartCount(cart.item_count);
    var drawer = $("#mna-cart");
    if (!drawer) return;
    var body = $("[data-cart-body]", drawer);
    var footer = $("[data-cart-footer]", drawer);
    var threshold = parseInt(drawer.getAttribute("data-free-shipping"), 10) || 0;

    if (cart.item_count === 0) {
      body.innerHTML = emptyCartHTML(drawer);
      if (footer) footer.hidden = true;
      return;
    }
    body.innerHTML = freeShippingHTML(cart.total_price, threshold) + "<ul class=\"cart-lines\">" +
      cart.items.map(lineHTML).join("") + "</ul>";
    if (footer) {
      footer.hidden = false;
      $("[data-cart-subtotal]", footer).textContent = formatMoney(cart.total_price);
    }
  }

  function freeShippingHTML(subtotal, threshold) {
    return ""; // barra de frete grátis oculta temporariamente (2026-07-07) — remover esta linha para reativar
    if (!threshold) return "";
    var missing = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, (subtotal / threshold) * 100);
    var label = missing > 0
      ? "Falta <strong>" + formatMoney(missing) + "</strong> para o frete grátis"
      : "Você ganhou <strong>frete grátis</strong>!";
    return '<div class="cart-free"><p class="cart-free__label">' + label +
      '</p><div class="cart-free__bar"><span style="transform:scaleX(' + (pct / 100) + ')"></span></div></div>';
  }

  /*
   * O "de/por" do produto não vem no /cart.js — a Cart API não expõe
   * compare_at_price. Vem do endpoint público do produto, um request por produto
   * distinto, guardado por handle: preço de produto não muda no meio da sessão.
   *
   * Falhar aqui custa o preço riscado, nunca o carrinho: guarda vazio e segue.
   */
  var compareByHandle = {};

  // Devolve true quando algo novo chegou — para não repintar o carrinho à toa.
  function loadCompareAt(cart) {
    var handles = (cart.items || [])
      .map(function (item) { return item.handle; })
      .filter(function (handle, i, all) {
        return handle && all.indexOf(handle) === i && !compareByHandle[handle];
      });
    if (!handles.length) return Promise.resolve(false);
    return Promise.all(handles.map(function (handle) {
      return fetch("/products/" + handle + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          var mapa = {};
          ((product && product.variants) || []).forEach(function (v) {
            if (v.compare_at_price) mapa[v.id] = v.compare_at_price;
          });
          compareByHandle[handle] = mapa;
        })
        .catch(function () { compareByHandle[handle] = {}; });
    })).then(function () { return true; });
  }

  // Duas origens de "antes": desconto de linha (vem no /cart.js) e o
  // comparativo do produto. Havendo os dois, vale o maior.
  function comparePriceHTML(item) {
    var doProduto = (compareByHandle[item.handle] || {})[item.variant_id] || 0;
    var full = Math.max(item.original_price || 0, doProduto);
    if (!full || full <= item.final_price) return "";
    return '<s class="cline__compare">' + formatMoney(full) + "</s>";
  }

  // Ícone de cupom, como o do drawer do tema. currentColor segue o verde.
  var TAG_ICON = '<svg class="cline__discount-icon" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M2.2 7.6V2.8a.6.6 0 0 1 .6-.6h4.8l6.2 6.2-5.4 5.4z"/><circle cx="5.2" cy="5.2" r="1"/></svg>';

  // Etiquetas de desconto da linha ("Oferta", brinde). O valor é o da linha
  // inteira, como o Shopify o entrega; o preço ao lado é por unidade, então os
  // dois só divergem com quantidade maior que um.
  function lineDiscountsHTML(item) {
    return (item.line_level_discount_allocations || [])
      .map(function (allocation) {
        return '<span class="cline__discount">' + TAG_ICON +
          escapeHTML(allocation.discount_application.title) +
          " · −" + formatMoney(allocation.amount) + "</span>";
      })
      .join("");
  }

  function lineHTML(item) {
    var img = item.image
      ? '<div class="product-img"><img src="' + item.image.replace(/(\.[^./]+)(\?|$)/, "_120x$1$2") + '" alt="" loading="lazy"></div>'
      : '<div class="product-img product-img--ph tone-magenta">' + (cfg.bottleSvg || "") + "</div>";
    return '<li class="cline" data-line-key="' + item.key + '">' +
      '<div class="cline__thumb">' + img + "</div>" +
      '<div class="cline__info"><p class="cline__name">' + item.product_title + "</p>" +
      lineDiscountsHTML(item) +
      '<p class="cline__price">' + comparePriceHTML(item) + formatMoney(item.final_price) + "</p>" +
      '<div class="cline__qty" role="group">' +
      '<button data-qty-dec aria-label="Diminuir quantidade">' + (cfg.icons.minus || "−") + "</button>" +
      '<span aria-live="polite">' + item.quantity + "</span>" +
      '<button data-qty-inc aria-label="Aumentar quantidade">' + (cfg.icons.plus || "+") + "</button>" +
      "</div></div>" +
      '<button class="cline__remove" data-qty-remove aria-label="Remover">' + (cfg.icons.trash || "×") + "</button>" +
      "</li>";
  }

  function emptyCartHTML(drawer) {
    return '<div class="cart-empty"><span class="cart-empty__icon">' + (cfg.icons.bag || "") + "</span>" +
      '<p class="cart-empty__title">Seu carrinho está vazio</p>' +
      '<p class="cart-empty__text">' + (drawer.getAttribute("data-empty-text") || "Comece pelo nosso Nº1.") + "</p>" +
      '<a class="btn btn--primary btn--md" href="' + (cfg.routes.allProducts || "/collections/all") + '" data-cart-close>Ver produtos</a></div>';
  }

  // Recusa da Shopify (422), com o motivo em `description` — é como chega o
  // limite de valor do carrinho (app zolve-meno-aliv, ADR 0028). O corpo não é
  // um carrinho: desenhado como um, o contador mostrava "undefined".
  function cartRefusal(body) {
    return body && body.status && body.description ? body.description : "";
  }

  // Depois do redesenho, que troca o corpo do drawer inteiro.
  function showCartNotice(message) {
    var body = $("[data-cart-body]", $("#mna-cart"));
    if (!body) return;
    var notice = document.createElement("p");
    notice.className = "cart-notice";
    notice.setAttribute("role", "alert");
    notice.textContent = message;
    body.insertBefore(notice, body.firstChild);
  }

  function changeLine(key, qty) {
    return fetch(cfg.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (body) {
      var refusal = cartRefusal(body);
      if (!refusal) return renderCart(body);
      return refreshCart(true).then(function () { showCartNotice(refusal); });
    });
  }

  function initCartEvents() {
    on(document, "click", function (e) {
      var line = e.target.closest("[data-line-key]");
      if (!line) return;
      var key = line.getAttribute("data-line-key");
      var qtyEl = $(".cline__qty span", line);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest("[data-qty-inc]")) changeLine(key, qty + 1);
      else if (e.target.closest("[data-qty-dec]")) changeLine(key, qty - 1);
      else if (e.target.closest("[data-qty-remove]")) changeLine(key, 0);
    });
    // O order bump e o brinde do app mexem no carrinho por fora daqui; sem isto
    // a lista do drawer ficaria velha até o próximo reload.
    on(document, "zolve:cart:updated", function (e) {
      if (e.detail && e.detail.source === "mna") return;
      refreshCart(true);
    });
  }

  // Fecha o modal do quiz (ex.: ao comprar por um card de resultado, pra não cobrir o carrinho).
  function closeQuizModal() {
    var q = $("[data-quiz-modal]");
    if (q && q.classList.contains("is-open")) {
      q.classList.remove("is-open");
      q.setAttribute("aria-hidden", "true");
    }
  }

  function initAddToCart() {
    on(document, "click", function (e) {
      var btn = e.target.closest("[data-add-to-cart]");
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute("data-variant-id");
      if (!id || btn.disabled) return;
      btn.disabled = true;
      fetch(cfg.routes.cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function (body) {
          return refreshCart().then(function () { return cartRefusal(body); });
        })
        .then(function (refusal) {
          closeQuizModal();
          openDrawer($("#mna-cart"));
          if (refusal) return showCartNotice(refusal);
          btn.classList.add("is-added");
          setTimeout(function () { btn.classList.remove("is-added"); }, 1600);
        })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    });
  }

  /* -------------------------------------------------------- search overlay */
  function initSearch() {
    var overlay = $("#mna-search");
    if (!overlay || overlay.__mna) return;
    overlay.__mna = true;
    var input = $("[data-search-input]", overlay);
    var popular = $("[data-search-popular]", overlay);
    var results = $("[data-search-results]", overlay);
    var debounce = null;

    // CTA "Falar com especialista": abre o WhatsApp já com o termo pesquisado.
    // Se o termo for muito longo ou tiver caracteres fora da whitelist, usa msg genérica.
    var WA_NUMBER = "551930917145";
    var WA_GENERIC = "Olá! Preciso de ajuda para encontrar o produto ideal para mim.";
    function specialistWaUrl(term) {
      term = (term || "").trim();
      var msg = WA_GENERIC;
      var ok = term && term.length <= 80 && /^[\wÀ-ÿ\s.,&+\-!?()\/'%]+$/.test(term);
      if (ok) msg = 'Olá! Pesquisei por "' + term + '" no site e gostaria de ajuda para encontrar o ideal.';
      return "https://wa.me/" + WA_NUMBER + "?text=" + encodeURIComponent(msg);
    }

    on(document, "click", function (e) {
      if (e.target.closest("[data-search-open]")) {
        e.preventDefault();
        overlay.classList.add("is-open");
        lockScroll(true);
        setTimeout(function () { input && input.focus(); }, 60);
      }
      if (e.target.closest("[data-search-close]")) {
        overlay.classList.remove("is-open");
        lockScroll(false);
        if (input) input.value = "";
        showPopular();
      }
      var chip = e.target.closest("[data-search-chip]");
      if (chip && input) { input.value = chip.textContent.trim(); query(input.value); }
    });

    function showPopular() {
      if (popular) popular.hidden = false;
      if (results) { results.hidden = true; results.innerHTML = ""; }
    }
    function query(q) {
      q = (q || "").trim();
      if (!q) { showPopular(); return; }
      if (popular) popular.hidden = true;
      if (results) { results.hidden = false; results.innerHTML = '<p class="search__loading">Buscando…</p>'; }
      var url = cfg.routes.predict + "?q=" + encodeURIComponent(q) +
        "&section_id=mna-predictive-results&resources[type]=product&resources[limit]=8" +
        "&resources[options][fields]=" + encodeURIComponent("title,product_type,variants.title,variants.sku,vendor,tag");
      fetch(url, { headers: { "Content-Type": "text/html" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (!results) return;
          results.innerHTML = html;
          var cta = results.querySelector("[data-search-specialist]");
          if (cta) cta.href = specialistWaUrl(q);
        })
        .catch(function () { if (results) results.innerHTML = ""; });
    }

    on(input, "input", function () {
      clearTimeout(debounce);
      var v = input.value;
      debounce = setTimeout(function () { query(v); }, 220);
    });
  }

  /* ----------------------------------------------------- newsletter (UX) */
  function initNewsletter(root) {
    collect(".mna-newsletter", root).forEach(function (form) {
      if (form.__mna) return;
      form.__mna = true;
      var input = $("input[type=email]", form);
      var err = $("[data-nl-error]", form);
      on(form, "submit", function (e) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (input && !re.test(input.value.trim())) {
          e.preventDefault();
          input.setAttribute("aria-invalid", "true");
          if (err) err.hidden = false;
        }
      });
      on(input, "input", function () {
        input.removeAttribute("aria-invalid");
        if (err) err.hidden = true;
      });
    });
  }

  /* ---------------------------------------------------- UGC vídeo (reels) */

  // Antecedência do buffer: ~meia tela antes da seção entrar. Curto o bastante
  // pra não custar nada em quem nunca rola até lá, longo pra dar ~1s de rede.
  var UGC_WARM_MARGIN = "500px 0px";

  // Posters: margem nos DOIS eixos de propósito. O carrossel é horizontal, e
  // "visível" muda com a largura — no desktop é a fileira inteira, no mobile é
  // o cartão atual e o próximo. Deixar a geometria decidir evita hardcodar
  // quantidade por breakpoint.
  var UGC_POSTER_MARGIN = "300px";

  // dispara fn uma única vez, quando el chega perto da viewport
  function onApproach(el, margin, fn) {
    if (!el || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      fn();
    }, { rootMargin: margin });
    io.observe(el);
  }

  // O atributo poster não tem lazy nativo: sem isto os 10 baixam no load.
  function applyUgcPoster(v) {
    var src = v && v.getAttribute("data-poster");
    if (!src) return;
    v.poster = src;
    v.removeAttribute("data-poster");
  }

  // Sai de preload="none" e começa a bufferizar. Só o vídeo que dá autoplay
  // passa por aqui; os outros 9 só carregam se o usuário clicar.
  function warmUgcVideo(v) {
    if (!v || v.__warm) return;
    v.__warm = true;
    v.preload = "auto";
    v.load();
  }

  function initUgcVideo() {
    var videos = $all("[data-ugc-video] video");
    if (!videos.length) return;
    var current = null; // só um vídeo pode estar tocando por vez

    function pauseVideo(v) {
      if (!v) return;
      v.pause();
      if (v.parentElement) v.parentElement.classList.remove("is-playing", "is-sound");
      if (current === v) current = null;
    }

    function playVideo(v, withSound) {
      if (current && current !== v) pauseVideo(current); // para o anterior
      v.muted = !withSound; // autoplay exige mudo; clique ativa o volume
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      current = v;
      if (v.parentElement) {
        v.parentElement.classList.add("is-playing");
        v.parentElement.classList.toggle("is-sound", !!withSound);
      }
    }

    on(document, "click", function (e) {
      var btn = e.target.closest("[data-ugc-video]");
      if (!btn) return;
      var v = btn.querySelector("video");
      if (!v) return;
      // tocando com som -> pausa; senão toca com som (1º clique do autoplay ativa o volume)
      if (!v.paused && !v.muted) pauseVideo(v);
      else playVideo(v, true);
    });

    on(document, "ended", function (e) {
      var v = e.target;
      if (v && v.matches && v.matches("[data-ugc-video] video")) pauseVideo(v);
    }, true);

    // Posters antes do guard abaixo: são imagens, não animação, então valem
    // mesmo com reduced-motion. Sem IntersectionObserver, aplica todos.
    if ("IntersectionObserver" in window) {
      videos.forEach(function (v) {
        onApproach(v, UGC_POSTER_MARGIN, function () { applyUgcPoster(v); });
      });
    } else {
      videos.forEach(function (v) { applyUgcPoster(v); });
    }

    // autoplay mudo do 1º vídeo quando entra na viewport; pausa quem sai da tela
    if (prefersReduced || !("IntersectionObserver" in window)) return;
    var first = videos[0];
    onApproach(first, UGC_WARM_MARGIN, function () { warmUgcVideo(first); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio >= 0.5) {
          if (en.target === first && !current) playVideo(first, false);
        } else if (!en.target.paused) {
          pauseVideo(en.target);
        }
      });
    }, { threshold: [0, 0.5] });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ------------------------------------------------------------ megamenu */
  function initMegaMenu() {
    var nav = $("[data-mna-mega]");
    if (!nav || nav.__mna) return;
    nav.__mna = true;
    var items = $all("[data-mega-item]", nav);
    var active = null, openT = null, closeT = null, scrim = null;
    var isDesktop = function () { return window.matchMedia("(min-width: 1024px)").matches; };

    function clearTimers() { clearTimeout(openT); clearTimeout(closeT); }
    function panelOf(it) { return $("[data-mega-panel]", it); }
    function trigOf(it) { return $("[data-mega-trigger]", it); }

    function showScrim() {
      if (scrim || !isDesktop()) return;
      scrim = document.createElement("button");
      scrim.className = "mega__scrim";
      scrim.setAttribute("aria-label", "Fechar menu");
      scrim.tabIndex = -1;
      on(scrim, "click", closeNow);
      document.body.appendChild(scrim);
    }
    function hideScrim() { if (scrim) { scrim.parentNode && scrim.parentNode.removeChild(scrim); scrim = null; } }

    function setActive(i) {
      items.forEach(function (it, idx) {
        var on_ = idx === i, panel = panelOf(it), trig = trigOf(it);
        if (panel) { panel.classList.toggle("is-open", on_); panel.setAttribute("aria-hidden", on_ ? "false" : "true"); }
        if (trig && trig.tagName === "BUTTON") trig.setAttribute("aria-expanded", on_ ? "true" : "false");
      });
      active = i;
      if (i === null) hideScrim(); else showScrim();
    }
    function openNow(i) { clearTimers(); setActive(i); }
    function closeNow() { clearTimers(); setActive(null); }
    function scheduleOpen(i) { clearTimers(); openT = setTimeout(function () { setActive(i); }, 70); }
    function scheduleClose() { clearTimers(); closeT = setTimeout(function () { setActive(null); }, 150); }

    items.forEach(function (it, i) {
      var trig = trigOf(it), hasPanel = !!panelOf(it);
      on(it, "mouseenter", function () { if (!isDesktop()) return; hasPanel ? scheduleOpen(i) : closeNow(); });
      if (!hasPanel || !trig) return;
      on(trig, "click", function () { clearTimers(); setActive(active === i ? null : i); });
      on(trig, "keydown", function (e) {
        if (e.key !== "ArrowDown") return;
        e.preventDefault();
        openNow(i);
        var link = $(".mega__link", panelOf(it));
        if (link) requestAnimationFrame(function () { link.focus(); });
      });
    });

    on(nav, "mouseleave", function () { if (isDesktop()) scheduleClose(); });
    on(nav, "mouseenter", function () { clearTimeout(closeT); });
    on(nav, "focusout", function (e) { if (!nav.contains(e.relatedTarget)) closeNow(); });
    on(window, "scroll", function () { if (active !== null) closeNow(); }, { passive: true });
    on(document, "keydown", function (e) {
      if (e.key !== "Escape" || active === null) return;
      var trig = trigOf(items[active]);
      closeNow();
      if (trig) trig.focus();
    });
  }

  /* --------------------------------------------------------------- quiz */
  var QUIZ_QUESTIONS = [
    { id: "focus", prompt: "O que mais atrapalha o seu dia hoje?", options: [
      { label: "Ondas de calor e calorões", value: "calor" },
      { label: "Noites mal dormidas", value: "sono" },
      { label: "Cansaço, falta de energia e libido", value: "energia" },
      { label: "Irritabilidade e oscilação de humor", value: "humor" },
      { label: "Vários sintomas ao mesmo tempo", value: "geral" }
    ] },
    { id: "freq", prompt: "Com que frequência os sintomas aparecem?", options: [
      { label: "Quase todos os dias", value: "alta" },
      { label: "Algumas vezes por semana", value: "media" },
      { label: "De vez em quando", value: "baixa" }
    ] }
  ];

  function quizRecommend(a) {
    var meno = a.freq === "alta" ? "meno-aliv-90" : "meno-aliv-30";
    var byFocus = {
      energia: { primary: "meno-aliv-intense", reason: "O Meno Intense foi feito para energia, vitalidade e libido, ajudando a reacender a sua intensidade no dia a dia." },
      sono: { primary: meno, complement: "gummy-melatonina", reason: "O Meno Aliv regula a fase e ajuda no sono, e a Gummy de Melatonina reforça as suas noites." },
      humor: { primary: meno, complement: "yes-calm", reason: "O Meno Aliv equilibra os hormônios que mexem com o humor, e o Yes Calm soma calma e bem-estar emocional." },
      calor: { primary: meno, complement: "meno-fresh", reason: "O Meno Aliv trata os fogachos por dentro, e o spray Meno Fresh dá o alívio imediato nos momentos de calor." }
    };
    if (a.focus && byFocus[a.focus]) return byFocus[a.focus];
    return { primary: meno, reason: "O Meno Aliv é o nosso Nº1: alívio completo dos sintomas da TPM, climatério e menopausa, do início ao fim." };
  }

  function initQuiz() {
    var modal = $("[data-quiz-modal]");
    if (!modal || modal.__mna) return;
    modal.__mna = true;
    var stage = $("[data-quiz]", modal);
    var store = $("[data-quiz-store]", modal);
    var closeBtn = $(".qmodal__close", modal);
    var icons = cfg.icons || {};
    var answers = {}, step = 0;

    function storeEl(id) { return store ? $('[data-quiz-card="' + id + '"]', store) : null; }
    function cardHTML(id) {
      var el = storeEl(id);
      if (el) return el.innerHTML;
      return '<div class="quiz__fallback"><a class="btn btn--primary btn--md" href="/collections/menopausa-tpm" data-quiz-close>Ver os produtos</a></div>';
    }
    function complementHTML(id) {
      var el = storeEl(id);
      if (!el) return "";
      return '<p class="quiz__complement">Combina bem com <a href="' + el.getAttribute("data-url") + '">' +
        el.getAttribute("data-name") + "</a>.</p>";
    }
    function progressHTML() {
      var total = QUIZ_QUESTIONS.length, shown = Math.min(step + 1, total);
      var dots = QUIZ_QUESTIONS.map(function (q, i) {
        return '<span class="quiz__dot' + (i <= step ? " is-on" : "") + '"></span>';
      }).join("");
      return '<div class="quiz__progress"><span class="quiz__progress-label">Pergunta ' + shown + " de " + total +
        '</span><span class="quiz__dots" aria-hidden="true">' + dots + "</span></div>";
    }
    function questionHTML() {
      var q = QUIZ_QUESTIONS[step];
      var opts = q.options.map(function (o) {
        return '<li><button class="quiz__option" type="button" data-quiz-pick="' + o.value + '"><span>' +
          o.label + "</span>" + (icons.arrowRight || "") + "</button></li>";
      }).join("");
      var back = step > 0 ? '<button class="quiz__back" type="button" data-quiz-back>' + (icons.arrowLeft || "") + " Voltar</button>" : "";
      return progressHTML() + '<div class="quiz__stage" tabindex="-1" aria-live="polite"><div class="quiz__question">' +
        '<h3 class="quiz__prompt">' + q.prompt + '</h3><ul class="quiz__options">' + opts + "</ul></div></div>" + back;
    }
    function resultHTML() {
      var rec = quizRecommend(answers);
      return '<div class="quiz__stage" tabindex="-1" aria-live="polite"><div class="quiz__result">' +
        '<p class="quiz__result-kicker">' + (icons.flower || "") + " O ideal para você é</p>" +
        '<div class="quiz__result-card">' + cardHTML(rec.primary) + "</div>" +
        '<p class="quiz__reason">' + rec.reason + "</p>" + (rec.complement ? complementHTML(rec.complement) : "") +
        '<button class="quiz__restart" type="button" data-quiz-restart>' + (icons.rotateCcw || "") + " Refazer o teste</button>" +
        "</div></div>";
    }
    function render() {
      stage.innerHTML = step >= QUIZ_QUESTIONS.length ? resultHTML() : questionHTML();
      var st = $(".quiz__stage", stage);
      if (st) st.focus();
    }

    function open() { answers = {}; step = 0; render(); modal.classList.add("is-open"); modal.setAttribute("aria-hidden", "false"); lockScroll(true); setTimeout(function () { closeBtn && closeBtn.focus(); }, 60); }
    function close() { modal.classList.remove("is-open"); modal.setAttribute("aria-hidden", "true"); lockScroll(false); }

    on(document, "click", function (e) {
      if (e.target.closest("[data-quiz-open]")) { e.preventDefault(); open(); }
      if (e.target.closest("[data-quiz-close]")) close();
    });
    on(document, "keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("is-open")) close(); });
    on(stage, "click", function (e) {
      if (e.target.closest("[data-quiz-pick]")) { answers[QUIZ_QUESTIONS[step].id] = e.target.closest("[data-quiz-pick]").getAttribute("data-quiz-pick"); step++; render(); }
      else if (e.target.closest("[data-quiz-back]")) { if (step > 0) { step--; render(); } }
      else if (e.target.closest("[data-quiz-restart]")) { answers = {}; step = 0; render(); }
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot(root) {
    initAnnouncement(root);
    initHeader(root);
    initHero(root);
    initCarousels(root);
    initTrust(root);
    initNewsletter(root);
  }

  function bootOnce() {
    initDrawerTriggers();
    initCartEvents();
    initAddToCart();
    initSearch();
    initUgcVideo();
    initMegaMenu();
    initQuiz();
    if (cfg.routes) refreshCart();
  }

  if (document.readyState !== "loading") { boot(document); bootOnce(); }
  else { on(document, "DOMContentLoaded", function () { boot(document); bootOnce(); }); }

  // Theme Editor: re-inicializa seções recarregadas
  on(document, "shopify:section:load", function (e) { boot(e.target); initSearch(); initMegaMenu(); initQuiz(); });
})();
